module.exports = __webpack_public_path__ + "static/img/3.03581b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/3.png
// module id = j4Q1
// module chunks = 0